export default "__VITE_ASSET__165d70b8__"